module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-records"
  }, [_c('div', {
    staticClass: "pane"
  }, [(_vm.labels) ? _c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.list,
      "max-height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "",
      "label": "序号",
      "prop": "seq",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "日期",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.dateReadable(scope.row.created_at)))])]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.labels), function(label) {
    return _c('el-table-column', {
      key: label.key,
      attrs: {
        "label": label.name,
        "prop": label.key
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    },
    attrs: {
      "current-page": _vm.current_page,
      "page-size": _vm.page_size,
      "layout": "total, prev, pager, next",
      "total": _vm.total_items
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.current_page = $event
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "link",
    on: {
      "click": _vm.removeSelections
    }
  }, [_vm._v("删除选中")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": ("/projects/" + (_vm.$route.params.id) + "/form_records/export.xls"),
      "target": "_blank"
    }
  }, [_vm._v("导出表单")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e88ebcd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/stats/form.view.vue
// module id = 954
// module chunks = 3